import React from 'react'

const Faq = () => {
  return (
    <h1>Faq Page</h1>
  )
}

export default Faq